import Lock from "@mui/icons-material/Lock";
import { Chip, type ChipProps } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

export const RestrictedChip: FC<ChipProps> = ({ ...props }) => {
  const { t } = useTranslation();

  return (
    <Chip
      variant="outlined"
      size="small"
      color="warning"
      icon={<Lock />}
      label={t("RESTRICTED")}
      {...props}
    />
  );
};
